import { AssetLocationMeta } from '/@/modules/asset/models/meta/AssetLocationMeta';
import { AssetLocation } from '/@/modules/asset/enums/AssetLocation';
import Lang from '/@/modules/core/app/services/Lang';

export class CashAssetMeta extends AssetLocationMeta {
  constructor(model = {}) {
    super(model);
  }

  /**
   * @returns {string}
   */
  get title() {
    return this.location
      ? AssetLocation.getByKey(this.location).value
      : Lang.t('accounting.cash-and-currencies');
  }
}
